import api from 'api'

export type UserProfile = {
  id: string
  firebaseId?: string
  name?: string
  email?: string
  phoneNumber?: string
  profilePicUrl?: string
  w2Status: string
  hasWorkwhileAdmin: boolean
  hasCompanyRole: boolean
  hasWorkerProfile: boolean
  userType: 'standard' | 'demo' | 'system'
  status:
    | 'account_created'
    | 'active'
    | 'disabled'
    | 'suspended'
    | 'blocked'
    | 'not_in_market'
    | 'deleted'
    | 'onboarding'
  shadowBlocked: boolean
  createdAt: string
  lastSeen?: string
  timezone: string
  shiftCount: number
  employerRole?: string
  whitelistedCompanyIds: number[]
}

/**
 * Fetch an admin-facing user profile.
 */
export async function getUserProfileById(userId: number): Promise<UserProfile> {
  const response = await api.get<UserProfile>(`/admin/user/${userId}/profile`)
  return response.data
}
